/* eslint-disable camelcase */

import { IUser } from '@rhybus/api'
import { anewWhoHttp } from './anew-who-http'
import { anewAuthCrudHttp } from './anew-auth-crud-http'
export const getAllUsersFromGroupName = async (groupName: string) => {
  try {
    const users = anewWhoHttp().Role(groupName)
    return users
  } catch (error) {
    console.error('Error getting user information:', error)
    throw error
  }
}
export const addUserToSql = async (selectedRole: string, selectedUserId: string) => {
  await anewAuthCrudHttp().RoleAddUser(selectedRole, selectedUserId)
}
export const removeUserFromSql = async (selectedRole: string, selectedUserId: string) => {
  await anewAuthCrudHttp().RoleRemoveUser(selectedRole, selectedUserId)
}
export const getUserSuggestionsSQL = async (query: string): Promise<any> => {
  const users = await anewWhoHttp().Picker(query)
  return users
}
export const getUserByUserId = async (userId: string): Promise<IUser> => {
  try {
    const userPickerModel = await anewWhoHttp().OtherByUserId(userId)
    const user: any = {
      userId: userPickerModel.rid,
      isDirty: false,
      edipi: userPickerModel.edipi,
      email: userPickerModel.email,
      mobilephone: userPickerModel.mobilePhone,
      persona: userPickerModel.persona, // first and last name
      firstName: '',
      lastName: '',
      roles: [],
      roleCodes: [],
      userAditinalInfo: userPickerModel.userAdditionalDetails
      
    }
    return user
  } catch (error) {
    console.error(`Failed to fetch user with ID ${userId}:`, error)
    if (error.response && error.response.status === 404) {
      // Handle 404 error: user not found
      throw new Error(`User with ID ${userId} not found.`)
    }
    throw error
  }
}